"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnualPay = AnnualPay;
exports.BirthDay = BirthDay;
exports.ContributionPercent = ContributionPercent;
exports.IncomeGoalPercent = IncomeGoalPercent;
exports.InflationRate = InflationRate;
exports.LifeExpectancy = LifeExpectancy;
exports.RetirementAge = RetirementAge;
exports.RetirementSavings = RetirementSavings;
exports.RorPostRetirement = RorPostRetirement;
exports.RorPreRetirement = RorPreRetirement;
exports.SalaryGrowthRate = SalaryGrowthRate;
exports.SsBenefit = SsBenefit;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _RetirementIncomeWizardCalc = require("./RetirementIncomeWizardCalc.config");
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function BirthDay(props) {
  var {
    errors,
    touched,
    birthDay,
    birthMonth,
    birthYear,
    birthdate,
    retirementAge,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = props;

  // Set birthdate field based on three separate, dependent fields
  _react.default.useEffect(() => {
    var parsedDate = (0, _parse.default)("".concat(birthMonth, "-").concat(birthDay, "-").concat(birthYear), 'M-d-y', new Date());
    setFieldValue('birthdate', parsedDate);
  }, [birthDay, birthMonth, birthYear, touched.birthdate, setFieldValue]);

  // Set birthdate touched after all three fields have been touched
  _react.default.useEffect(() => {
    setFieldTouched('birthdate', touched.birthMonth && touched.birthDay && touched.birthYear);
  }, [touched.birthDay, touched.birthMonth, touched.birthYear]);

  // Set retirementAge when applicable
  _react.default.useEffect(() => {
    var isBirthdateError = errors.birthdate;
    var age = (0, _utils.calculateAge)(birthDay, birthMonth, birthYear);
    var isInvalidRetirementAge = age >= retirementAge;
    if (!isBirthdateError && isInvalidRetirementAge) {
      setFieldValue('retirementAge', age + 1);
    }
  }, [birthdate]);

  // Override errors in order sequential order
  _react.default.useEffect(() => {
    var firstBirthdateError = [errors.birthMonth, errors.birthDay, errors.birthYear, errors.birthdate].find(val => !!val);
    setFieldError('birthdate', firstBirthdateError);
  }, [errors.birthDay, errors.birthMonth, errors.birthYear, touched.birthDay, touched.birthMonth, touched.birthYear]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "ri_birthMonth"
  }, "Birth Month"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "ri_birthMonth",
    name: "birthMonth",
    id: "ri_birthMonth",
    placeholder: "MM",
    maxLength: "2",
    value: birthMonth,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, 'monthOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "ri_birthDay"
  }, "Birth Day"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "ri_birthDay",
    name: "birthDay",
    id: "ri_birthDay",
    placeholder: "DD",
    maxLength: "2",
    value: birthDay,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, 'dayOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "ri_birthYear"
  }, "Birth Year"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "ri_birthYear",
    name: "birthYear",
    id: "ri_birthYear",
    placeholder: "YYYY",
    maxLength: "4",
    value: birthYear,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, 'yearOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    className: "custom-feedback",
    type: "invalid"
  }, errors.birthdate)));
}
function RetirementAge(_ref) {
  var {
    errors,
    touched,
    values
  } = _ref;
  var fieldName = 'retirementAge';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var placeholder = '00';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Retirement Age",
    id: _RetirementIncomeWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function LifeExpectancy(_ref2) {
  var {
    errors,
    touched,
    values
  } = _ref2;
  var fieldName = 'lifeExpectancy';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var placeholder = '00';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Life Expectancy",
    id: _RetirementIncomeWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _RetirementIncomeWizardCalc.popoverConfig.lifeExpectancy
  });
}
function AnnualPay(_ref3) {
  var {
    errors,
    touched,
    values
  } = _ref3;
  var fieldName = 'annualPay';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Annual Pay",
    id: _RetirementIncomeWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function ContributionPercent(_ref4) {
  var {
    errors,
    touched,
    values
  } = _ref4;
  var fieldName = 'contributionPercent';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '6';
  var placeholder = '00.00';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Current Contributions",
    id: _RetirementIncomeWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function RetirementSavings(_ref5) {
  var {
    errors,
    touched,
    values
  } = _ref5;
  var fieldName = 'savings';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Current Retirement Savings Total",
    id: _RetirementIncomeWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function SsBenefit(_ref6) {
  var {
    errors,
    touched,
    values
  } = _ref6;
  var fieldName = 'ssBenefit';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Annual Social Security Benefit at Retirement",
    id: _RetirementIncomeWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _RetirementIncomeWizardCalc.popoverConfig.ssBenefit
  });
}
function IncomeGoalPercent(_ref7) {
  var {
    errors,
    touched,
    values
  } = _ref7;
  var fieldName = 'incomeGoalPercent';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '6';
  var placeholder = '00.00';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Percent Of Current Income",
    id: _RetirementIncomeWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    popoverText: _RetirementIncomeWizardCalc.popoverConfig.incomeGoalPercent,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function SalaryGrowthRate(_ref8) {
  var {
    errors,
    touched,
    values
  } = _ref8;
  var fieldName = 'salaryGrowth';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '6';
  var placeholder = '00.00';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Salary Growth Rate",
    id: _RetirementIncomeWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    popoverText: _RetirementIncomeWizardCalc.popoverConfig.salaryGrowth,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function InflationRate(_ref9) {
  var {
    errors,
    touched,
    values
  } = _ref9;
  var fieldName = 'inflationRate';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '6';
  var placeholder = '00.00';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Inflation Rate",
    id: _RetirementIncomeWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    popoverText: _RetirementIncomeWizardCalc.popoverConfig.inflationRate,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function RorPostRetirement(_ref10) {
  var {
    errors,
    touched,
    values
  } = _ref10;
  var fieldName = 'rorPostRetirement';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '6';
  var placeholder = '00.00';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Rate of Return Pre-Retirement",
    id: _RetirementIncomeWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    popoverText: _RetirementIncomeWizardCalc.popoverConfig.rorPreRetirement,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function RorPreRetirement(_ref11) {
  var {
    errors,
    touched,
    values
  } = _ref11;
  var fieldName = 'rorPreRetirement';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '6';
  var placeholder = '00.00';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Rate of Return Post-Retirement",
    id: _RetirementIncomeWizardCalc.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    type: type,
    popoverText: _RetirementIncomeWizardCalc.popoverConfig.rorPostRetirement,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}